import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BaseCellComponent } from '@adnova/jf-ng-components';

import { AnnouncementTableItem } from '../+definitions';

/**
 * Datumsformat für die Anzeige in der Zeitraum-Spalte.
 *
 * Format: Tag.Monat.Jahr (z.B. 01.12.2025)
 */
const DATE_FORMAT = 'dd.MM.yyyy';

/**
 * Cell-Komponente für die Zeitraum-Spalte in der Announcement-Tabelle.
 *
 * Zeigt den aktiven Zeitraum des Announcements im Format "DD.MM.YYYY - DD.MM.YYYY" an.
 * Der Zeitraum wird aus den Feldern `activeFrom` und `activeUntil` gebildet.
 *
 * @extends BaseCellComponent<AnnouncementTableItem>
 */
@Component({
  selector: 'app-zeitraum-cell',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './zeitraum-cell.component.html',
  styleUrls: ['./zeitraum-cell.component.scss'],
})
export class ZeitraumCellComponent extends BaseCellComponent<AnnouncementTableItem> {

  /**
   * Datumsformat für die Anzeige.
   * Wird im Template verwendet.
   */
  readonly dateFormat = DATE_FORMAT;
}
